import { theme } from "antd";
import React, { useEffect, useState } from "react";

type TableFilterProps = {
  defaultIndex?: number;
  filters: any[];
  setSelectedFilterIndex: (index: number) => void;
};

const TableFilter: React.FC<TableFilterProps> = ({
  defaultIndex,
  filters,
  setSelectedFilterIndex,
}) => {
  const { token } = theme.useToken();
  const [selectedIndex, setSelectedIndex] = useState(0);

  useEffect(() => {
    if (defaultIndex && defaultIndex !== 0) {
      setSelectedIndex(defaultIndex);
    }
  }, [defaultIndex]);

  return (
    <div
      style={{
        color: "Poppins",
        display: "flex",
        gap: 0,
        borderBottom: "1px solid #B0BABD",
      }}
    >
      {filters.map((filter, index) => (
        <div
          onClick={() => {
            setSelectedIndex(index);
            setSelectedFilterIndex(index);
          }}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            fontWeight: "bold",
            fontSize: 16,
            cursor: "pointer",
            padding: "10px 20px",
            borderBottom:
              index === selectedIndex
                ? `2px solid  ${token.colorPrimary}`
                : `0px`,
            color: `${
              index === selectedIndex ? token.colorPrimary : "#B0BABD"
            }`,
          }}
        >
          {filter.label}{" "}
          <div
            style={{
              padding: "3px 6px",
              borderRadius: 4.3,
              backgroundColor:
                index === selectedIndex
                  ? `${token.colorPrimary}44`
                  : `#B0BABD44`,
            }}
          >
            {isNaN(filter.count) ? 0 : filter.count}
          </div>
        </div>
      ))}
    </div>
  );
};

export default TableFilter;
